import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col, Modal, Form} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import {darkBlue, hover, text, title, white} from "../styles/globalStyleVars";
import Button from "./Button";
import {gsap, TimelineLite} from "gsap";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import Title from "./Title";
import {apiEndPoints} from "../api/network/apiEndPoints";
import {postForm} from "../api/redux/home";


const MyComponent = ({isProjectPage}) => {

    const [modalOpen, setModalOpen] = useState(false); // Added state for modal


    // modal
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setModalOpen(false); // Set modal state to closed when modal is closed
        document.documentElement.classList.remove('modal-open'); // Remove class
    };

    const handleShow = () => {
        setShow(true);
        setModalOpen(true); // Set modal state to open when modal is shown
        document.documentElement.classList.add('modal-open'); // Add class
    };


    useEffect(() => {
        if (modalOpen) {
            document.documentElement.style.overflowY = 'hidden';
        } else {
            document.documentElement.style.overflowY = 'scroll';
        }

        return () => {
            // Cleanup: reset the style when the component unmounts
            document.documentElement.style.overflowY = 'scroll';
        };
    }, [modalOpen]);

    const location = useLocation()

    // menu fixed on scroll
    useEffect(() => {
        if (document.body.classList.contains('scroll-down')) {
            document.body.classList.remove('scroll-down');
        }
    });


    useEffect(() => {
        const body = document.body;
        const scrollUp = 'scroll-up';
        const scrollDown = 'scroll-down';
        let lastScroll = 0;
        let howMuchScroll;

        if (window.screen.width < 991) {
            howMuchScroll = 150;
        } else {
            howMuchScroll = 150;
        }

        window.addEventListener('scroll', () => {
            let currentScroll = window.pageYOffset;

            if (currentScroll <= howMuchScroll) {
                body.classList.remove(scrollUp);
                body.classList.remove(scrollDown);
                return;
            }

            if (currentScroll > lastScroll && currentScroll > howMuchScroll) {
                // down
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (currentScroll < lastScroll && currentScroll > howMuchScroll) {
                // up
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }

            lastScroll = currentScroll;
        });
    }, []);


    //----- mobile menu action
    useEffect(() => {
        let getMobileMenuBar = document.querySelector('.main-menu-mobile');
        let getItemsParent = document.querySelector('.main-menu-mobile__items');

        let getItems = document.querySelectorAll('.main-item');

        let getBacks = document.querySelectorAll('.sub-menu-back');
        let getHamburgerClick = document.querySelector('#open-click')
        let getHamburgerCloseClick = document.querySelector('#close-click')
        let tl = new TimelineLite();
        let tl2 = new TimelineLite();

        // menu open toggle
        getHamburgerClick.addEventListener('click', () => {
            getMobileMenuBar.classList.add('menu-open')
            document.body.classList.add('stop-scroll')
            tl2.to(getItemsParent, {
                duration: .2,
                display: 'block',
            }).to(getItemsParent, {
                duration: .2,
                x: 0
            }, '-=.2')


        })

        getHamburgerCloseClick.addEventListener('click', () => {
            getMobileMenuBar.classList.remove('menu-open')
            document.body.classList.remove('stop-scroll')
            if (document.querySelector('.main-item.active')) {
                getItemsParent.classList.remove('active')
                document.querySelector('.main-item.active').classList.remove('active')
            }

            tl2.to(getItemsParent, {
                duration: .2,
                x: '100%'
            }).to(getItemsParent, {
                duration: .2,
                display: 'none'
            })
        });


        // sub menu toggle
        getItems.forEach(i => {
            i.addEventListener('click', () => {
                getItemsParent.classList.add('active')
                i.classList.add('active')
            })
        })

        getBacks.forEach(i => {
            i.addEventListener('click', (e) => {

                getItemsParent.classList.remove('active')
                i.parentNode.parentElement.classList.remove('active')
                e.stopPropagation()
            })
        })

        // on click a tag menu hide
        let getAlla = document.querySelectorAll('.main-menu-mobile a');
        getAlla.forEach(i => {
            i.addEventListener('click', (e) => {
                // e.stopPropagation();
                getMobileMenuBar.classList.remove('menu-open');
                document.body.classList.remove('stop-scroll');
                // console.log('have or not', document.querySelector('.main-item.active'))
                setTimeout(() => {
                    if (document.querySelector('.main-item.active')) {

                        getItemsParent.classList.remove('active')
                        document.querySelector('.main-item.active').classList.remove('active')
                    }
                }, 300)

                tl2.to(getItemsParent, {
                    duration: .3,
                    x: '100%'
                }).to(getItemsParent, {
                    duration: .3,
                    display: 'none'
                })
            })
        })

    }, [])



    //Form

    const dispatch = useDispatch();
    const responseData = useSelector(state => state.contact);

    const {register, handleSubmit ,formState,reset} = useForm({mode: 'all'});

    //--- form submit
    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });
    const onSubmit = (e) => {

        let api_services = apiEndPoints.CONTACT_FORM;

        var formData = new FormData();
        formData.append('your-name', e?.name);
        formData.append('your-email', e?.email);
        formData.append('your-phone', e?.phone);
        formData.append('your-message', e?.message);

        if (e.email !== '' && e.name !== '' && e.phone !== '' && e?.message!=='') {
            dispatch(postForm([api_services, formData]));
            success('Successfully Submitted')
            reset();
        }
    };
    let count=0;
    const onError = (errors) => {
        Object.values(errors).forEach((error) => {
            count++;
        });
        if(count>0){
            toast.error('please fill out the correct inputs');
        }
        count=0;
    };
    useEffect(() => {
        if (responseData && responseData?.error !== '') {
            error(responseData?.error)
        }
        if (responseData && responseData?.success !== '') {
            // success(responseData?.success)
        }

    }, [responseData])

    // on click hide menu
    useEffect(() => {
        const getAList = document.querySelectorAll('.main-menu__left li');
        getAList.forEach(e => {
            e.addEventListener('click', function () {
                if (e.querySelector('ul')) {
                    e.querySelector('ul').style.display = 'none'
                }
                setTimeout(() => {
                    const getUl = document.querySelectorAll('.main-menu__left li ul')
                    getUl.forEach(e => {
                        e.removeAttribute('style')
                    })
                }, 300)
            });
        })
    }, [])


    return (

        <>
            {/*desktop menu */}
            <StyledComponent className={'main-menu'} isProjectPage={isProjectPage}>
                <Container className={'d-flex justify-content-between'}>

                    <div className="main-menu__left">
                        <div className="main-menu__left__logo">
                            <Link to={'/'}><img src="/images/static/logo-white.svg" alt=""/></Link>
                        </div>

                        <ul>
                            <li><Link className={location.pathname === '/' ? 'active' : ''} to={'/'}>Home</Link></li>
                            <li><Link
                                className={location.pathname === '/about' || location.pathname === '/newsroom' || location.pathname === '/career' || location.pathname === "/voices" ? 'active' : ''}
                                to={'#'}>About Us</Link>
                                <ul>
                                    <li><Link to={'/about'}>Who We Are</Link></li>
                                    <li><Link to={'/about#overview'}>Mission and Vision</Link></li>
                                    <li><Link to={'/about#management'}>Management Team</Link></li>
                                    <li><Link to={'/about#directors'}>Board of Directors</Link></li>
                                    <li><Link to={'/about#corporate-values'}>Sister Concern</Link></li>
                                </ul>
                            </li>
                            <li><Link className={location.pathname === '/projects' ? 'active' : ''} to={'/projects'}>Projects</Link></li>
                            <li><Link className={location.pathname === '/equipments' ? 'active' : ''} to={'/equipments'}>Equipments</Link></li>
                            <li><Link className={location.pathname === '/contact' ? 'active' : ''} to={'/contact'}>Contact</Link></li>

                            {/*<li><Link to={'/find-us'}>invest</Link></li>*/}



                        </ul>
                    </div>

                    <div className="main-menu__right">
                        {/*<Button src={'/invest'} margin={'0 20px 0 0'}*/}
                        {/*        padding={'11px 30px 9px 30px'}*/}
                        {/*        hoverBackground={'#FFF'}*/}
                        {/*        hoverColor={text}*/}
                        {/*        background={'transparent'}*/}
                        {/*        border={'1px solid #FFF'}*/}
                        {/*        text={'Invest Now'}/>*/}
                        <Button onClick={handleShow} src={'#'} margin={'0 20px 0 0'} padding={'11px 30px 9px 30px'}
                                hoverBackground={'#FFF'}
                                hoverColor={text} background={hover}
                            // border={'1px solid #FFF'}
                                text={'Get in Touch'}/>
                        {/*<div className="search">*/}
                        {/*    <img src="/images/static/search.svg" alt=""/>*/}
                        {/*</div>*/}
                    </div>
                </Container>
            </StyledComponent>

            {/*mobile menu*/}
            <StyledMobileMenu className='main-menu-mobile'>
                <div className="main-menu-mobile__bar">
                    <div className="main-menu-mobile__bar__logo">
                        <Link href={'/'}><a><img alt='' src={'/images/static/logo-white.svg'}/></a></Link>
                    </div>

                    <div className="main-menu-mobile__bar__hamburger">
                        <ul>

                            <li className='hover-here'>

                                <svg id='open-click' xmlns="http://www.w3.org/2000/svg" width="32" height="18"
                                     viewBox="0 0 32 18">
                                    <g id="Group_19820" data-name="Group 19820" transform="translate(-329 -31)">
                                        <line id="Line_3" data-name="Line 3" x2="30" transform="translate(330 32)"
                                              fill="none" stroke="#f2f2f2" stroke-linecap="round" stroke-width="2"/>
                                        <line id="Line_4" data-name="Line 4" x2="30" transform="translate(330 40)"
                                              fill="none" stroke="#f2f2f2" stroke-linecap="round" stroke-width="2"/>
                                        <line id="Line_5" data-name="Line 5" x2="30" transform="translate(330 48)"
                                              fill="none" stroke="#f2f2f2" stroke-linecap="round" stroke-width="2"/>
                                    </g>
                                </svg>


                                <svg id='close-click' xmlns="http://www.w3.org/2000/svg" width="24.042"
                                     height="24.042"
                                     viewBox="0 0 24.042 24.042">
                                    <g id="Group_24004" data-name="Group 24004"
                                       transform="translate(-337.372 -27.979)">
                                        <line id="Line_4" data-name="Line 4" x2="30"
                                              transform="translate(338.787 29.393) rotate(45)" fill="none"
                                              stroke="#f2f2f2" stroke-linecap="round" stroke-width="2"/>
                                        <line id="Line_12435" data-name="Line 12435" x2="30"
                                              transform="translate(360 29.393) rotate(135)" fill="none"
                                              stroke="#f2f2f2"
                                              stroke-linecap="round" stroke-width="2"/>
                                    </g>
                                </svg>


                            </li>
                        </ul>
                    </div>
                </div>

                <div className="main-menu-mobile__items">
                    <ul>
                        <li onClick={handleShow}><a style={{width: '100%', display: 'block'}} href={'/#'}><img
                            style={{width: 'calc(100vw - 30px)',margin:'0 0 60px'}}
                            src="/images/static/btn.svg"
                            alt=""/></a>
                        </li>

                        <li className='main-item'>
                            <Link to={'/'}> Home</Link>
                            <span/>
                        </li>

                        <li className='main-item'>
                            About Us
                            <span><img src="/images/static/mb-arrow.svg" alt=""/></span>
                            <ul>
                                <p className='sub-menu-back'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                         viewBox="0 0 24 24">
                                        <g id="Group_19650" data-name="Group 19650"
                                           transform="translate(26 26) rotate(180)">
                                            <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(2 2)"
                                               fill="none" stroke="#f2f2f2" stroke-width="1">
                                                <circle cx="12" cy="12" r="12" stroke="none"/>
                                                <circle cx="12" cy="12" r="11.5" fill="none"/>
                                            </g>
                                            <g id="Group_15708" data-name="Group 15708"
                                               transform="translate(13 11)">
                                                <line id="Line_7" data-name="Line 7" x2="3" y2="3" fill="none"
                                                      stroke="#f2f2f2" stroke-linecap="round" stroke-width="1"/>
                                                <line id="Line_8" data-name="Line 8" y1="3" x2="3"
                                                      transform="translate(0 3)" fill="none" stroke="#f2f2f2"
                                                      stroke-linecap="round" stroke-width="1"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <strong>About Us</strong>
                                </p>
                                {/*<h3>About Us</h3>*/}

                                <li><Link to={'/about#whoweare'}>Who We Are</Link></li>
                                <li><Link to={'/about#mission-vision'}>Mission and Vision</Link></li>
                                <li><Link to={'/about#management'}>Management Team</Link></li>
                                <li><Link to={'/about#sister-concern'}>Sister Concern</Link></li>

                            </ul>
                        </li>
                        <li className='main-item'><Link to={'/projects'}>Projects</Link></li>
                        <li className='main-item'><Link to={'/equipments'}>Equipments</Link></li>
                        <li className='main-item'><Link to={'/contact'}>Contact</Link></li>
                    </ul>
                </div>

            </StyledMobileMenu>


            {/*bootstrap modal */}

            <Modal className={'get-touched'} show={show} onHide={handleClose}>
                <div className="slide-form">
                    <h4>Get in Touch Today!</h4>
                    <Form onSubmit={handleSubmit(onSubmit,onError)}>
                        <Form.Group>

                            <Form.Control
                                className={formState?.errors?.name?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                {...register("name",{
                                    required: 'Username is required',
                                })}
                                type="text"
                                placeholder="Name*"/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Control
                                className={formState?.errors?.email?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                {...register("email",{
                                    required:{
                                        value:true,
                                        message:'please enter your email'
                                    },
                                    pattern:{
                                        value:/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message:'please enter a valid email address'
                                    }
                                })}
                                type="email"
                                placeholder="Email*"/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Control
                                className={formState?.errors?.phone?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                {...register("phone",{
                                    required:{
                                        value:true,
                                        message:'please enter your phone first'
                                    },
                                    pattern:{
                                        value:/^01[0-9]{9}$/,
                                        message:'please enter a valid 11 digit phone number'
                                    }
                                })}
                                type="number"
                                placeholder="Phone Number*"/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Control
                                className={formState?.errors?.message?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                {...register("message",{
                                    required:{
                                        value:true,
                                        message:'please enter your email'
                                    },

                                })}
                                type="textarea"
                                placeholder="Message (Optional)"/>
                        </Form.Group>

                        <div className="close-btn hover" onClick={handleClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10.829" height="10.828"
                                 viewBox="0 0 10.829 10.828">
                                <g id="Group_20272" data-name="Group 20272" transform="translate(-3166.586 -119.586)">
                                    <g id="Group_18979" data-name="Group 18979" transform="translate(1 -1.5)">
                                        <line id="Line_4" data-name="Line 4" x2="8" y2="8"
                                              transform="translate(3167 122.5)"
                                              fill="none" stroke="#3b3838" stroke-linecap="round" stroke-width="2"/>
                                        <line id="Line_3877" data-name="Line 3877" x1="8" y2="8"
                                              transform="translate(3167 122.5)" fill="none" stroke="#3b3838"
                                              stroke-linecap="round" stroke-width="2"/>
                                    </g>
                                </g>
                            </svg>

                        </div>
                        <div  onClick={handleSubmit(onSubmit,onError)}>
                            <Button width={'fit-content'} text={'Submit Message'} color={`${white}`} border={`1px solid ${text}`} />                            {/*<Button margin={'60px 0 0 0'} color={`${white}`} background={'transparent'}*/}
                            {/*        border={`1px solid ${white}`}*/}
                            {/*        text={'Submit Message'}/>*/}
                        </div>

                    </Form>
                </div>
            </Modal>
        </>

    );
};

// desktop menu
const StyledComponent = styled.section`
  height: 80px;
  background-color: ${props => props?.isProjectPage ? 'rgba(20, 38, 55, 0.5)' : ''};
  backdrop-filter: blur(5px);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
  transition: .5s ease;

  .dc-btn {
    margin: 0px;
  }

  @media (max-width: 767px) {
    display: none !important;
  }


  .main-menu__left {
    display: flex;
    align-items: center;

    &__logo {
      margin-right: 60px;
      img{
        width: 96px;
        height: 45px !important;
      }
    }

    ul {
      &:not(li ul) {
        display: flex;
      }

      li {
        a {
          color: ${white};
          height: 80px;
          display: flex;
          align-items: center;
          text-transform: capitalize;

          &.active {
            // color: ${hover};
            border-bottom: 2px solid ${white};
          }
          &:hover{
            // border-bottom: 2px solid ${white};
          }
        }

        &:not(:nth-last-child(1)) a {
          margin-right: 30px;
        }


        ul {
          position: absolute;
          background-color: ${darkBlue};
          padding: 40px;
          min-width: 280px;
          visibility: hidden;
          opacity: 0;
          transition: .4s ease;
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);

          li {
            a {
              font-weight: 500;
              color: ${white};
              height: fit-content;
              margin-right: 0 !important;
            }

            &:not(:nth-last-child(1)) a {
              border-bottom: 1px solid rgba(255, 255, 255, 0.2);
              padding-bottom: 12px;
              margin-bottom: 17px;
            }
            
          }
        }

        &:hover {
          ul {
            visibility: visible;
            opacity: 1;
            li{
              &:last-child{
                border-bottom: 1px solid transparent !important;
              }
            }
          }
        }
      }
    }
  }

  .main-menu__right {
    display: flex;
    align-items: center;

    .search {
      min-height: 40px;
      max-height: 40px;
      min-width: 40px;
      max-width: 40px;
      border-radius: 50%;
      border: 1px solid #FFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      img {
        z-index: 2;
      }

      &:before {
        inset: unset !important;
        bottom: 0;
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 0px !important;
        left: 0 !important;
        background-color: ${p => p.hoverBackground || `${hover}`};
        margin: auto;
        transition: all .5s ease;
        height: 100%;
        width: 0%;
        border-radius: 27px;
      }

      &:hover {
        &:before {
          height: 100%;
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 1150px) {
    .main-menu__left__logo {
      margin-right: 30px;

      img {
        height: 30px;
      }
    }

    .main-menu__left ul li {
      a {
        font-size: 15px;
      }

      &:not(:nth-last-child(1)) a {
        margin-right: 25px;
      }
    }

    .dc-btn {


      a {
        padding-right: 15px;
        padding-left: 15px;
        font-size: 14px;
      }
    }

  }

  @media (max-width: 950px) {
    display: none;
  }

`;

// mobile menu

const StyledMobileMenu = styled.section`
  position: fixed;
  width: 100%;
  z-index: 99999;
  top: 0;
  left: 0;
  //height: 100vh;
  //overflow-x: hidden;
  //overflow-y: auto;
  //background-color: #fff;
  //display: none;
  //transition: all .4s ease;

  @media (min-width: 991px) {
    display: none;
  }

  .main-menu-mobile__bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding: 0 15px;
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    background-color: ${darkBlue};
    z-index: 999;
    transition: all .4s ease;
    height: 80px;

    &__hamburger {
      ul {
        display: flex;
        height: 90px;
        align-items: center;

        li {
          //&:nth-of-type(1) {
          //  margin-right: 15px;
          //}

          svg {
            &:nth-of-type(2) {
              display: none;
            }
          }
        }
      }
    }
    &__logo{
      img{
        width: 72px;
      }
    }


  }


  .main-menu-mobile__items {
    padding: 0 15px;
    position: relative;
    transform-origin: top left;
    transition: all .3s ease-out;
    //display: none;
    height: calc(100vh);
    //margin-top: 170px;
    //overflow-x: hidden;
    //overflow-y: auto;
    overflow-y: auto;
    padding-bottom: 10px;
    padding-top: 120px;
    overflow-x: hidden;
    background-color: ${darkBlue};
    width: 200vw;
    transform: translateX(100%);
    display: none;

    ul {
      width: 100%;

      li {
        text-transform: capitalize;
        display: block;
        width: 100%;
        color: #f2f2f2;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        //position: relative;

        &.main-item {
          //border-bottom: 1px solid rgba(198, 198, 198, 0.5);
          //padding-bottom: 15px;

          span {
            content: '';
            width: calc(100vw - 30px);
            background-color: rgba(198, 198, 198, 0.5);
            //position: absolute;
            //bottom: 0;
            //left: 0;
            height: 1px;
            display: block;
            margin-top: 10px;
            position: relative;

            img {
              position: absolute;
              right: 0;
              bottom: 15px;
            }
          }

          &:nth-last-child(1) span {
            background-color: transparent;
          }
        }

        &:hover {
          color: ${hover};
        }

        &:not(:nth-last-of-type(1)) {
          margin-bottom: 20px;

        }

        a {
          color: #f2f2f2;
          font-size: 20px;
          line-height: 28px;
          font-weight: 500;
        }

        //sub menus
        ul {
          left: 0;
          list-style: none;
          margin: 0;
          position: absolute;
          top: 130px;
          padding: 0 15px;
          //height: 100vh;
          opacity: 0;
          transform: translate3d(100vw, 0, 0);
          transition: all .3s ease;
          //padding-bottom: 40px;
          width: 100vw;
          padding-bottom: 25px;

          p {
            margin-bottom: 35px;

            svg {
              margin-top: -5px;
            }

            strong {
              border-color: transparent !important;
              font-size: 20px;
              font-weight: 500;
              color: ${white};
              padding-left: 20px;
              line-height: 28px;
            }

          }

          h3 {
            font-size: 30px;
            line-height: 40px;
            font-weight: 400;
            font-family: ${title};
            margin: 0;
            text-transform: capitalize;
            padding-bottom: 20px;
            border-bottom: 1px solid ${hover};
            margin-bottom: 40px;
          }

          li {
            &:not(:nth-last-of-type(1)) {
              //margin-bottom: 30px;
              margin-bottom: 20px;

              a {
                border-bottom: 1px solid rgba(198, 198, 198, 0.5);
              }
            }

            a {
              font-size: 20px;
              line-height: 28px;
              text-transform: capitalize;
              display: block;
              width: 100%;

              padding-bottom: 15px;
              color: #f2f2f2;
            }

          }
        }

        &.active {
          ul {
            opacity: 1;
            z-index: 2;
          }
        }

      }
    }

    &.active {
      transform: translate3d(-100vw, 0, 0) !important;
    }
  }

  //toggle action
  &.menu-open {
    .main-menu-mobile__bar {
      background-color:${darkBlue};

      &__logo {
        img {
            // content: url(${"LogoBlack"});
        }
      }

      &__hamburger {
        li:nth-of-type(1) {
          svg {
            g {
              stroke: ${text};
            }

            path {
              fill: ${text};
            }
          }
        }

        #open-click {
          display: none;
        }

        #close-click {
          display: block;
        }
      }
    }
  }
`;

export default React.memo(MyComponent);
